// Legacy quest campaign shown as "Legacy Score"
export const LEGACY_CAMPAIGN_ID = "spicenet";
export const SATSUMA_CAMPAIGN = {
  campaignId: "satsuma-points-november-2026",
  campaignGroup: "1",
  partnerId: "satsuma",
  startsAt: "2026-11-03T05:00:00.000Z",
  endsAt: "2026-11-10T05:00:00.000Z",
  points: 5000,
  appUrl: "https://www.satsuma.exchange/",
} as const;
export const PARE_CAMPAIGN = {
  campaignId: "pare-points-september-2026",
  campaignGroup: "1",
  partnerId: "pare",
  startsAt: "2026-09-28T15:00:00.000Z",
  endsAt: "2026-10-08T15:00:00.000Z",
  points: 5000,
  requiredTransactions: 3,
  minimumUsd: 5,
  appUrl: "https://parestocks.com/app.html",
  supportedNetworks: [
    "Ethereum",
    "BNB Chain",
    "Polygon",
    "Monad",
    "Citrea",
    "Robinhood Chain",
    "Base",
    "Arbitrum One",
  ],
} as const;
export const LEGACY_CAMPAIGN_GROUP_ID = "1";

// Mainnet partner campaign used for the private beta partner app.
export const MAINNET_CAMPAIGN_ID = "spicenet-mainnet-private-beta";
export const MAINNET_CAMPAIGN_GROUP_ID = "1";

// Temporary compatibility exports for parts of the app still on the old model.
// These remain unchanged until Dashboard / Apps / Leaderboard are migrated.
export const CAMPAIGN_ID = "spicenet";
export const CAMPAIGN_OLD_ID = LEGACY_CAMPAIGN_ID;
export const CAMPAIGN_GROUP_ID = LEGACY_CAMPAIGN_GROUP_ID;
export const CAMPAIGN_OLD_GROUP_ID = LEGACY_CAMPAIGN_GROUP_ID;

export const CAMPAIGN_CONFIG = {
  id: CAMPAIGN_ID,
  groupId: CAMPAIGN_GROUP_ID,
  oldId: CAMPAIGN_OLD_ID,
  oldGroupId: CAMPAIGN_OLD_GROUP_ID,
} as const;

export const LEGACY_CAMPAIGN_CONFIG = {
  id: LEGACY_CAMPAIGN_ID,
  groupId: LEGACY_CAMPAIGN_GROUP_ID,
} as const;

export const MAINNET_CAMPAIGN_CONFIG = {
  id: MAINNET_CAMPAIGN_ID,
  groupId: MAINNET_CAMPAIGN_GROUP_ID,
} as const;

export const PORTAL_WALLET_LINK_CONFIG = {
  id: "spicenet-portal",
  groupId: "1",
} as const;

export const ACTIVE_MAINNET_PARTNER_IDS = ["reppo"] as const;

export const MAINNET_PARTNER_QUESTS = {
  reppo: {
    name: "Reppo",
    feedbackFormUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLSfifOxThUSQJ-415RVt4Sw0Qe1uexoiPK9lk9xcGwPRn1uS3w/viewform?usp=publish-editor",
    tasks: ["Lock REPPO", "Access datanet", "Publish pod", "Vote on pod"],
  },
} as const;

export const FUN_MARKETS_CAMPAIGN = {
  campaignId: "fun-markets-october-2026",
  campaignGroup: "1",
  partnerId: "fun-markets",
  startsAt: "2026-10-30T04:00:00.000Z",
  endsAt: "2026-11-03T05:00:00.000Z",
  points: 5000,
  appUrl: "https://funmarkets.io",
} as const;
